/*
  INSERT INTO _30rs (
    _dmn, 
    _key, _vsn, _ltt, _fst, 
    _icn, _pfx,
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    0, 
    1, 1, 1, 1, 
    '1', 'クライアントA',
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );
*/
export const _30z = { // 組織
  _30r: { // 法人
    v0: {
      fldz: {
        _icn: {
          pfx: '法人ID'
        },
        _pfx: {
          pfx: '法人名'
        }
      },
    },
  },
};
